export interface VehicleData {
  id: string
  carrierCid: string
  telematicsReady: boolean
  type: string
  licensePlate: string
  vehicleType: VehicleType
  subType?: string
  weightCapacity?: number
  fuelType?: FuelType
  makeModel?: string
  assetId?: string
  lastPositionTimestamp?: string
  status?: string
}

export interface CreateOrEditVehicleFormValues {
  vehicleType: VehicleType
  licensePlate: string
  weightCapacity?: number
  fuelType?: FuelType
  makeModel?: string
  assetId?: string
}

export enum VehicleType {
  TRUCK = 'TRUCK',
  TRAILER = 'TRAILER',
}

export enum FuelType {
  DIESEL = 'DIESEL',
  PETROL = 'PETROL',
  CNG = 'CNG',
  LNG = 'LNG',
  ELECTRIC = 'ELECTRIC',
}
